// 裁處日期起訖區間上限（月）；供 layout.js 的 customCalendar 限制可選日期，只在本頁生效
window.calendarMaxRangeMonths = 60;

function VerifyHrefContent(params) {
  // 創建一個新的 URLSearchParams 來保存驗證後的參數
  const sanitizedParams = new URLSearchParams();

  // 迭代所有參數並進行驗證
  for (const [key, value] of params) {
    // 檢查鍵和值是否包含合法字符
    if (IsValidInput(key) && IsValidInput(value)) {
      // 將合法的參數加入到驗證後的參數中
      sanitizedParams.append(key, value);
    }
  }

  return sanitizedParams;
}

// 驗證輸入是否包含合法字符
function IsValidInput(input) {
  // 排除特定字符，允許英文日文中文等其他符號，for路標名稱
  const disallowedCharsRegex = /[<>\"']/;
  return !disallowedCharsRegex.test(input);
}

// 檢查裁處日期起訖區間是否在 5 年（含）以內，超過回傳 false
function IsDateRangeWithinLimit(startDate, endDate) {
  return moment(endDate).isSameOrBefore(moment(startDate).add(5, "years"));
}

// 檢查使用者輸入的起訖日期格式：有填的日期必須是 yyyy-mm-dd 且為存在的日期（例如 2026-02-30 不合法）
// 未填（空值）不在此檢查，交由後續「請選擇開始／結束日期」處理
function IsValidDateFormat(data) {
  return [data.StartDate, data.EndDate].every((date) => {
    if (date === null || date === undefined || String(date).trim() === "") return true;
    return /^\d{4}-\d{2}-\d{2}$/.test(String(date).trim()) && moment(String(date).trim(), "YYYY-MM-DD", true).isValid();
  });
}

const DATE_FORMAT_ERROR_TEXT = "請輸入正確的日期格式！";
const DATE_RANGE_ERROR_TEXT = "查詢區間限制在 5 年以內，請縮短裁處日期區間！";

// 裁處書字號格式：[污染類別代碼 2 碼]-[年度 3 碼]-[流水號 6 碼]，例如 21-115-081147
const DOCUMENT_NO_REGEX = /^\d{2}-\d{3}-\d{6}$/;
const DOCUMENT_NO_ERROR_TEXT = "請輸入正確的裁處書字號格式！";
const DOC_NO_ERROR = ".doc_no_error";

// 取得並整理（去除前後空白）裁處書字號，回傳是否有填；有填但格式錯誤時於輸入框下方顯示紅字並回傳 invalid
function CheckDocumentNo(data) {
  data.DocumentNo = (data.DocumentNo || "").trim();
  const hasDocNo = data.DocumentNo !== "";
  const invalid = hasDocNo && !DOCUMENT_NO_REGEX.test(data.DocumentNo);
  if (invalid) $(DOC_NO_ERROR).text(DOCUMENT_NO_ERROR_TEXT);
  return { hasDocNo, invalid };
}

// 事業名稱與統一編號至少須填其一（只填空白字元視同未填），兩者皆空回傳 false
function HasFacilityOrUniformNo(data) {
  return Boolean((data.FacilityName || "").trim() || (data.UniformNo || "").trim());
}

// 錯誤訊息容器：事業名稱／統一編號的提示顯示在事業名稱欄位下方，日期相關的顯示在日曆下方。
// 兩者皆為 .error（共用樣式），設定文字時需分別指定，避免同一則訊息同時出現在兩處。
const NAME_ERROR = ".error_name";
const DATE_ERROR = ".calendar_block .error";

let typeText = {
  PenaltyAgencyList: "裁處機關",
  Regulations: "法規",
  Law: "法條",
};
let fetchData = {
  FacilityName: "",
  County: "",
  PenaltyAgencyList: "",
  Regulations: "",
  Law: "",
  StartDate: null,
  EndDate: null,
  PageNumber: 1,
  PageSize: 5,
  UniformNo: "",
  DocumentNo: "",
};
// StartDate: moment().subtract(180, 'd').format("YYYY-MM-DD"),
// 	EndDate: moment().format("YYYY-MM-DD"),
$(document).ready(() => {
  document.title = "列管污染源資料 (含裁處資訊) 查詢系統-裁處資訊查詢";

  // 重新輸入裁處書字號時先清掉舊的錯誤訊息，避免改對了紅字還留著
  $("input[name='DocumentNo']").on("input", function () {
    $(DOC_NO_ERROR).text("");
  });

  $("input[type=text]").change(function () {
    let val = $(this).val();
    let name = $(this).attr("name");
    fetchData[name] = val;
  });

  if (mobileMediaQuery.matches) {
    $(".calendar_input").attr("placeholder", "起 ─ 迄");
    $(".declaration_amt").attr("placeholder", "半形數字可含小數點");
  }

  FETCHCODE(fetchData);
  $(".option_block").delegate("li", "click", function () {
    let this_ = $(this);
    let type = $(this_).parent(".option_block").data("type");
    let text = $(this_).text().trim();
    $(this_).parent(".option_block").children("li").removeClass("selected");
    $(this_).parent(".option_block").parent(".select_box").children("input").val(text);
    $(this_).addClass("selected");
    if (type === "Regulations") {
      let list_html = '<li class="selected"><button>全部</button></li>';
      $(".law_option_block").empty();
      $("#penaltyLaw").val("法條（全部）");
      fetchData.Law = "";
      if (text.indexOf("全部") === -1) {
        // --- 程式碼路徑：js/api/PenaltyCodeList.js ----- //
        FetchPenaltyCode("", $(".law_option_block"), "Law", fetchData, text, "");
      } else {
        $(".law_option_block").append(list_html);
      }
    }
    if (type == "PenaltyAgencyList") {
      if (text == "全部") {
        fetchData["County"] = "";
      } else {
        fetchData["County"] = text;
      }
    } else {
      if (text == "全部") {
        fetchData[type] = "";
      } else {
        fetchData[type] = text;
      }
    }
  });
  $(".down").click(function () {
    let select = $(this).prev("select");
    $(select).children("option").slideDown();
  });
  $(".select").each(function () {
    let this_ = $(this);
    this_
      .children(".select_box")
      .children(".option_block")
      .children("li")
      .each(function () {
        if ($(this).hasClass("selected")) {
          this_.children(".select_box").children(" input").val($(this).text().trim());
        }
      });
  });

  $(".select_down").click(function (e) {
    e.stopPropagation();
    const button = e.currentTarget;
    let options = $(this).next(".option_block");
    let open = $(this).hasClass("open");
    $(".select_down").removeClass("open");
    $(".option_block").slideUp();
    if (open) {
      $(this).removeClass("open");
      button.setAttribute("aria-expanded", "false");
      options.slideUp();
    } else {
      $(this).addClass("open");
      button.setAttribute("aria-expanded", "true");
      options.slideDown();
    }
  });
  let selected_start = fetchData.StartDate;
  let selected_end = fetchData.EndDate;
  let calendar_data = customCalendar(fetchData.StartDate, fetchData.EndDate);

  $(".calendar > .calender_content").delegate("table tbody td>button", "click", function (e) {
    e.stopPropagation();
    if (selected_start === "") {
      selected_start = $(this).parent("td").data("date");
    } else if (selected_end === "") {
      selected_end = $(this).parent("td").data("date");
    } else if (selected_start !== "" && selected_end !== "") {
      selected_start = $(this).parent("td").data("date");
      selected_end = "";
    }
    let table_index = $(this).parent("td").parent("tr").parent("tbody").parent("table").data("index");
    // --- 程式碼路徑：js/layout.js ----- //
    customCalendar(selected_start, selected_end, table_index);
  });
  $(".clear_calendar").click(function () {
    selected_start = fetchData.StartDate;
    selected_end = fetchData.EndDate;
    // --- 程式碼路徑：js/layout.js ----- //
    customCalendar(selected_start, selected_end);
  });
  $(".confirm_calendar").click(function (e) {
    e.stopPropagation();
    fetchData.StartDate = selected_start;
    fetchData.EndDate = selected_end;
    if (selected_start !== "" && selected_end !== "") {
      $(".calendar_input").val(`${selected_start} ─ ${selected_end}`);
    }
    $(".calendar").slideUp();
    $(".calendar_icon").removeClass("open");
  });
  $(".calendar").delegate("table td>button", "click", function (e) {
    let type = $(this).parents(".calendar_input").children("input").data("type");
    let value = $(this).parent("td").data("date");
    // 點日期一律以該日為選取值，確保輸入框正確帶入（清除請用清除按鈕）
    let selectedValue = value;

    $(this).parents(".calendar").slideUp(100);
    $(this).parents(".calendar").removeClass("open");
    fetchData[type] = selectedValue;
    $(this).parents(".calendar_input").children("input").val(selectedValue);
    if (type === "StartDate") {
      customCalendar(selectedValue, fetchData.EndDate ? fetchData.EndDate : "", selectedValue);
    }
  });
  $(".input_calendar_range .input").change(function (e) {
    let type = $(this).data("type");
    if (type) {
      fetchData[type] = e.target.value;
    }
  });
  $(".search_submit").click(function () {
    let final_variable = [];
    fetchData.PageNumber = 1;
    fetchData.PageSize = 5;
    $(".error").text("");
    $(DOC_NO_ERROR).text("");
    // 裁處書字號：格式須正確；有填時不強制檢查事業名稱／統一編號與裁處日期
    const { hasDocNo, invalid: docNoInvalid } = CheckDocumentNo(fetchData);
    // 先檢查日期格式，錯誤訊息顯示在日期輸入框下方
    const dateFormatInvalid = !IsValidDateFormat(fetchData);
    // 日期區間超過 5 年：與名稱錯誤並存時也要顯示（不被名稱檢查的 return 擋掉）
    const dateRangeInvalid = !dateFormatInvalid && fetchData.StartDate && fetchData.EndDate && !IsDateRangeWithinLimit(fetchData.StartDate, fetchData.EndDate);
    if (dateFormatInvalid) {
      $(DATE_ERROR).text(DATE_FORMAT_ERROR_TEXT);
    } else if (dateRangeInvalid) {
      $(DATE_ERROR).text(DATE_RANGE_ERROR_TEXT);
    }
    // 事業名稱與統一編號至少須填其一（有填裁處書字號時不檢查）
    if (!hasDocNo && !HasFacilityOrUniformNo(fetchData)) {
      $(NAME_ERROR).text("請輸入事業名稱或統一編號！");
      return;
    }
    if (docNoInvalid || dateFormatInvalid || dateRangeInvalid) return;
    // 未選擇日期時不查詢，提示使用者先選擇日期（與下載資料按鈕行為一致）；有填裁處書字號時日期可不填
    if (hasDocNo || (fetchData.StartDate && fetchData.EndDate)) {
      for (let data in fetchData) {
        if (fetchData[data] !== "" && fetchData[data] !== null && fetchData[data] !== undefined) {
          let obj = {
            [data]: fetchData[data],
          };
          final_variable.push(data);
        }
      }
      const urlParams = new URLSearchParams();
      final_variable.forEach((v) => {
        urlParams.append(v, fetchData[v]);
      });

      const sanitizedParams = VerifyHrefContent(urlParams.entries());

      const url = `./sanctions.html?${sanitizedParams.toString()}`;
      window.location.href = url;
    } else {
      $(DATE_ERROR).text(`請選擇${!fetchData.StartDate ? "開始" : "結束"}日期！`);
    }
  });
  $(".download_button").click(function (e) {
    // 由 DownloadPenaltyFile 以 fetch 下載，避免連結再觸發一次下載
    e.preventDefault();
    $(".error").text("");
    $(DOC_NO_ERROR).text("");
    const { hasDocNo, invalid: docNoInvalid } = CheckDocumentNo(fetchData);
    // 先檢查日期格式（與查詢按鈕行為一致）
    const dateFormatInvalid = !IsValidDateFormat(fetchData);
    const dateRangeInvalid = !dateFormatInvalid && fetchData.StartDate && fetchData.EndDate && !IsDateRangeWithinLimit(fetchData.StartDate, fetchData.EndDate);
    if (dateFormatInvalid) {
      $(DATE_ERROR).text(DATE_FORMAT_ERROR_TEXT);
    } else if (dateRangeInvalid) {
      $(DATE_ERROR).text(DATE_RANGE_ERROR_TEXT);
    }
    // 事業名稱與統一編號至少須填其一（與查詢按鈕行為一致；有填裁處書字號時不檢查）
    if (!hasDocNo && !HasFacilityOrUniformNo(fetchData)) {
      $(NAME_ERROR).text("請輸入事業名稱或統一編號！");
      return;
    }
    if (docNoInvalid || dateFormatInvalid || dateRangeInvalid) return;
    if (hasDocNo || (fetchData.StartDate && fetchData.EndDate)) {
      if ($(this).hasClass("disabled")) return;
      fetchData.PageNumber = "";
      fetchData.PageSize = -1;
      // 查無資料時以提示框告知，不下載 zip
      const button = $(this);
      CheckPenaltyHasData(button, "查詢中...", () => DownloadPenaltyFile(button, fetchData));
    } else {
      $(DATE_ERROR).text(`請選擇${!fetchData.StartDate ? "開始" : "結束"}日期！`);
    }
  });
  LoadPenaltyAllFileInfo();
  // 提示框為共用元件，關閉後清空內文，避免其他提示沿用「查無裁處資訊」的建議文字
  $(".modal_notification .modal_confirm").on("click", function () {
    setTimeout(() => $(".modal_notification .text").empty(), 200);
  });
});

// 依目前查詢條件確認是否有裁處資料：有資料才執行 onHasData，0 筆則以提示框告知
// 查詢期間按鈕停用並顯示 loadingText，避免重複點擊；API 失敗時照常執行 onHasData，交由後續頁面處理
function CheckPenaltyHasData(button, loadingText, onHasData) {
  if (button.hasClass("disabled") || button.prop("disabled")) return;

  const originalText = button.text();
  button.addClass("disabled").prop("disabled", true).text(loadingText);
  const restoreButton = () => button.removeClass("disabled").prop("disabled", false).text(originalText);

  $.ajax({
    url: `${host}api/v1/Penalty`,
    type: "GET",
    data: { ...fetchData },
    headers: { Accept: "application/json" },
  })
    .done(function (res) {
      restoreButton();
      const rowCount = res && res.Result ? res.Result.RowCount : null;
      if (rowCount === 0) {
        ShowNoPenaltyDataNotification();
        return;
      }
      onHasData();
    })
    .fail(function () {
      restoreButton();
      onHasData();
    });
}

function ShowNoPenaltyDataNotification() {
  $(".modal_notification .title").text("目前的查詢條件查無裁處資訊。");
  $(".modal_notification .text").html(
    `<div style="display: inline-block; text-align: left; font-weight: 400; line-height: 1.8">
      1. 請確認查詢條件是否正確。<br />
      2. 請調整裁處日期區間。<br />
      3. 請嘗試其他查詢條件。
    </div>`
  );
  // 150ms：比 jQuery 預設 400ms 快，提示較即時
  $(".modal_notification").fadeIn(150).css("display", "flex");
  $("body").css("overflow", "hidden");
}

// 「下載所有裁處資訊資料」：zip 由排程每日產出，載入頁面時取得筆數與檔案大小顯示在按鈕上
function LoadPenaltyAllFileInfo() {
  const button = $(".download_all_button");
  $.get(`${host}api/v1/Penalty/AllFileInfo`, function (data) {
    const info = data && data.Result;
    if (!info) {
      button.text("下載所有裁處資訊資料（檔案準備中）");
      return;
    }
    const countText = `${Math.round(info.RowCount / 10000)}萬筆`;
    const sizeText = `約${Math.max(1, Math.round(info.FileSize / 1024 / 1024))}MB`;
    button
      .text(`下載所有裁處資訊資料（${countText}，${sizeText}）`)
      .attr("href", `${host}api/v1/Penalty/AllFile`)
      .attr("title", `下載所有裁處資訊資料zip檔（含 Excel、CSV），資料產出時間 ${info.GeneratedTime}`)
      .removeClass("disabled");
    // 說明文字顯示檔案產出時間，讓使用者知道資料更新到何時
    $(".penalty_all_time").text(`，目前檔案產出時間：${info.GeneratedTime}`);
  }).fail(function () {
    button.text("下載所有裁處資訊資料（暫時無法下載）");
  });
}

const FETCHCODE = (Data) => {
  $(".option_block").each(function () {
    let this_ = $(this);
    let type = $(this_).data("type");
    if (type) {
      if (type === "Law") {
        // --- 程式碼路徑：js/api/PenaltyCodeList.js ----- //
        FetchPenaltyCode("", this_, type, Data, Data.Regulations, "");
      } else {
        // --- 程式碼路徑：js/api/PenaltyCodeList.js ----- //
        FetchPenaltyCode("", this_, type, Data);
      }
    }
  });
};

$(".clear_btn").click(function () {
  fetchData.StartDate = "";
  fetchData.EndDate = "";
  fetchData.FacilityName = "";
  fetchData.UniformNo = "";
  fetchData.DocumentNo = "";
  fetchData.PenaltyAgencyList = "";
  fetchData.Regulations = "";
  fetchData.Law = "";
  $(".calendar_input").children("input").val("");
  $("input[name='FacilityName']").val("");
  $("input[name='UniformNo']").val("");
  $("input[name='DocumentNo']").val("");
  $(DOC_NO_ERROR).text("");
  $("#penaltyAgent").val("裁處機關（全部）");
  $("#penaltyRegulations").val("法規（全部）");
  $("#penaltyLaw").val("法條（全部）");
  FETCHCODE(fetchData);
});
